/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M17.043 8.683a.588.588 0 0 1 .852 0l2.922 2.921c.242.244.242.609 0 .792l-2.922 2.922a.554.554 0 0 1-.426.182c-.366 0-.609-.243-.609-.609V12.9L3.9 12.9a.9.9 0 0 1-.893-.787L3 12a.9.9 0 0 1 .9-.9l12.96-.001v-1.99c0-.146.039-.254.117-.353l.066-.073Z"
})), "0 0 24 24", "FlightDirect");